import { render } from "./DatePickerOnly.vue?vue&type=template&id=36b91391&scoped=true"
import script from "./DatePickerOnly.vue?vue&type=script&lang=js"
export * from "./DatePickerOnly.vue?vue&type=script&lang=js"

import "./DatePickerOnly.vue?vue&type=style&index=0&id=36b91391&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b91391"]])

export default __exports__